(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/selectors/coupon-selectors.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/selectors/coupon-selectors.js'); "use strict";

const {
  createSelector
} = RTK;
const {
  constants
} = svs.components.tipsen.engine;
const {
  getPaymentConfirmMessage
} = svs.components.sport;
const {
  CurrencyAsJupiterString
} = svs.utils.format;
const {
  resolveITSProductId
} = svs.utils.products;
const {
  COUPON_VALID,
  COUPON_INVALID_NO_COMPLETE_BOARD,
  COUPON_INVALID_MAX_SIZE_EXCEEDED,
  COUPON_INVALID_REDUCE_COUNT_TOO_GREAT,
  COUPON_INVALID_REDUCE_COUNT_NOT_IN_RANGE,
  COUPON_INVALID_WRONG_HEDGES,
  COUPON_INVALID_WRONG_USIGNS,
  COUPON_INVALID_BELOW_GROUP_AMOUNT,
  COUPON_PRICE_IS_LOWER_THAN_MINSTAKE,
  COUPON_DONT_MATCH_COMPETITION_SYSTEMSIZE
} = svs.components.tipsen.engine.constants.couponStatus;
const {
  SYSTEM_MSYS,
  SYSTEM_RSYS,
  SYSTEM_USYS,
  SYSTEM_REDUCERA_FRITT
} = svs.components.tipsen.engine.constants.systems;
const {
  MSYS,
  SROW,
  RSYS,
  USYS,
  UROW
} = svs.components.tipsen.engine.constants.gameBoardSystemType;
const {
  QUICKPICK_WEIGHTED,
  QUICKPICK_PARTIAL,
  QUICKPICK_MODIFIED
} = svs.components.tipsen.engine.constants.quickpickProp;
const {
  BET_PROP_REDUCERA_FRITT,
  BET_PROP_MARKETPLACE,
  BET_PROP_MARKETPLACE_RETAILER
} = svs.components.tipsen.engine.constants.betProp;
const {
  Reducer
} = svs.components.sport.percentageReduce;
const {
  signDistributionConversion
} = svs.components.tipsen.engine.utils;
const {
  convert1X2ToBitmapRows
} = svs.components.sport.expandedSystems.utils;
const {
  selectActiveWallet,
  selectWalletBalance
} = svs.components.tipsen.walletSelectors;
const {
  WALLET_MARKETPLACE_RETAILER,
  WALLET_MARKETPLACE_PLAYER
} = svs.components.tipsen.wallet.walletType;
const {
  isMarketplaceWallet
} = svs.components.tipsen.wallet.walletHelpers;
const {
  BetslipCouponType
} = svs.components.tipsen.engine.constants;
const {
  selectCompetitionDetails,
  selectActiveCompetitionId
} = svs.components.marketplaceCompetition.services.selectors.competitionSelectors;
const {
  selectEngineDefinition,
  selectEngineDefinitionByProductId
} = svs.components.tipsen.engine.selectors;
const {
  selectExternalSystemChunkSize,
  selectAddonPixSizes
} = svs.components.tipsen.engine.selectors.engineSelectors;
const {
  makeSelectRelatedDraw
} = svs.components.sport.drawsRedux.selectors;
const {
  detect
} = svs.core;
const {
  selectors: {
    selectDraw
  }
} = svs.components.sport.drawsRedux;
const {
  flatArray
} = svs.components.lbUtils.flatArray;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const selectCoupon = (state, couponId) => state.Coupons[couponId];
const selectIsCouponExternal = (state, couponId) => state.Coupons[couponId].isExternal;
const selectCouponBoard = createSelector([(state, couponId) => selectCoupon(state, couponId), (state, couponId, boardIndex) => boardIndex], (coupon, boardIndex) => coupon === null || coupon === void 0 ? void 0 : coupon.boards[boardIndex]);
const selectBoardUserSigns = (state, couponId, boardIndex) => {
  var _selectCouponBoard;
  return ((_selectCouponBoard = selectCouponBoard(state, couponId, boardIndex)) === null || _selectCouponBoard === void 0 ? void 0 : _selectCouponBoard.userSigns) || [];
};
const selectCouponEventCount = function (state, couponId) {
  var _selectCouponBoard2;
  let boardIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return (((_selectCouponBoard2 = selectCouponBoard(state, couponId, boardIndex)) === null || _selectCouponBoard2 === void 0 ? void 0 : _selectCouponBoard2.signs) || []).length;
};
const selectUserSigns = (state, couponId) => selectBoardUserSigns(state, couponId, 0);
const selectSigns = createSelector(function (state, couponId) {
  let board = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return selectCouponBoard(state, couponId, board);
}, board => board === null || board === void 0 ? void 0 : board.signs);
const selectCouponEventStarted = createSelector(function (state, couponId) {
  let board = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return selectCouponBoard(state, couponId, board);
}, board => {
  const signs = board === null || board === void 0 ? void 0 : board.signs;
  let numberOfEventsStarted = 0;
  if (signs) {
    signs.forEach(event => {
      if (event.includes(true)) {
        numberOfEventsStarted += 1;
      }
    });
  }
  return numberOfEventsStarted;
});
const selectMSigns = function (state, couponId) {
  var _selectCouponBoard3;
  let board = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return (_selectCouponBoard3 = selectCouponBoard(state, couponId, board)) === null || _selectCouponBoard3 === void 0 ? void 0 : _selectCouponBoard3.mSigns;
};
const selectUSigns = function (state, couponId) {
  var _selectCouponBoard4;
  let board = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return (_selectCouponBoard4 = selectCouponBoard(state, couponId, board)) === null || _selectCouponBoard4 === void 0 ? void 0 : _selectCouponBoard4.uSigns;
};
const selectEventSelections = (state, couponId, board, event) => {
  const signs = selectSigns(state, couponId, board);
  return signs ? signs[event] : undefined;
};
const selectEventUserSelections = (state, couponId, board, event) => {
  const signs = selectBoardUserSigns(state, couponId, board);
  return signs[event];
};
const selectEventMSign = (state, couponId, board, event) => {
  const mSigns = selectMSigns(state, couponId, board);
  return mSigns ? mSigns[event] : undefined;
};
const selectEventUSign = (state, couponId, board, event) => {
  const uSigns = selectUSigns(state, couponId, board);
  return uSigns ? uSigns[event] : undefined;
};

const selectSelectedSystemType = (state, couponId) => {
  let system;
  const engineConfig = selectEngineDefinition(state);
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails) {
    system = competitionDetails.systemType;
  } else {
    var _selectCoupon;
    system = engineConfig.systems[((_selectCoupon = selectCoupon(state, couponId)) === null || _selectCoupon === void 0 ? void 0 : _selectCoupon.selectedSystem) || 0];
  }
  return system;
};
const selectRSystem = (state, couponId) => {
  let rSys = null;
  const engineConfig = selectEngineDefinition(state);
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails && competitionDetails.systemType === SYSTEM_RSYS) {
    rSys = competitionDetails.systemNumber; 
  } else {
    var _selectCoupon2;
    rSys = (_selectCoupon2 = selectCoupon(state, couponId)) === null || _selectCoupon2 === void 0 ? void 0 : _selectCoupon2.rSystem;
  }
  return engineConfig.rSystems[rSys];
};
const selectUSystem = (state, couponId) => {
  let uSys = null;
  const engineConfig = selectEngineDefinition(state);
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails && competitionDetails.systemType === SYSTEM_USYS) {
    uSys = competitionDetails.systemNumber; 
  } else {
    var _selectCoupon3;
    uSys = (_selectCoupon3 = selectCoupon(state, couponId)) === null || _selectCoupon3 === void 0 ? void 0 : _selectCoupon3.uSystem;
  }
  return engineConfig.uSystems[uSys];
};

const selectSystemType = (state, couponId) => {
  const system = selectSelectedSystemType(state, couponId);
  const rSys = selectRSystem(state, couponId);
  const uSys = selectUSystem(state, couponId);
  if (system === SYSTEM_RSYS && !rSys) {
    return SYSTEM_MSYS;
  }
  if (system === SYSTEM_USYS && !uSys) {
    return SYSTEM_MSYS;
  }
  return system;
};
const selectIsTransferrable = (state, couponId) => {
  var _coupon$isTransferabl;
  const systemType = selectSystemType(state, couponId);
  const coupon = selectCoupon(state, couponId);
  const transferrable = (_coupon$isTransferabl = coupon.isTransferable) !== null && _coupon$isTransferabl !== void 0 ? _coupon$isTransferabl : true;
  return transferrable && systemType !== SYSTEM_REDUCERA_FRITT;
};
const selectHalfHedges = (state, couponId, boardIndex) => {
  const systemType = selectSystemType(state, couponId);
  const signs = selectSigns(state, couponId, boardIndex) || [];
  return signs.filter((row, index) => {
    const selections = row.filter(Boolean).length;
    const moreThanOneSign = selections > 1;
    const notAllSigns = row.length !== selections;
    const noMSign = !((systemType === SYSTEM_RSYS || systemType === SYSTEM_USYS) && selectEventMSign(state, couponId, boardIndex, index));
    return moreThanOneSign && notAllSigns && noMSign;
  }).length;
};
const selectFullHedges = (state, couponId, boardIndex) => {
  const systemType = selectSystemType(state, couponId);
  const signs = selectSigns(state, couponId, boardIndex) || [];
  return signs.filter((row, index) => {
    const allSigns = row.length === row.filter(Boolean).length;
    const noMSign = !((systemType === SYSTEM_RSYS || systemType === SYSTEM_USYS) && selectEventMSign(state, couponId, boardIndex, index));
    return allSigns && noMSign;
  }).length;
};
const selectCouponSet = (state, couponId, boardIndex) => {
  const signs = selectSigns(state, couponId, boardIndex) || [];
  const set = {};
  signs.forEach(row => {
    const selectedCount = row.filter(sign => sign).length;
    if (!set[selectedCount]) {
      set[selectedCount] = 1;
    } else {
      set[selectedCount] += 1;
    }
  });
  return set;
};
const selectCurrentBetAmount = (state, couponId) => {
  var _selectCoupon4;
  return selectEngineDefinition(state).betAmounts[((_selectCoupon4 = selectCoupon(state, couponId)) === null || _selectCoupon4 === void 0 ? void 0 : _selectCoupon4.betAmountIndex) || 0];
};
const _selectSystemSize = signs => {
  const systemSize = signs.reduce((map, row) => {
    const selections = row.filter(Boolean).length;
    return selections ? map * selections : map;
  }, 1);
  return systemSize;
};
const selectUserSystemSize = (state, couponId, boardIndex) => {
  const signs = selectBoardUserSigns(state, couponId, boardIndex);
  return _selectSystemSize(signs);
};
const selectAllSigns = createSelector((state, couponId) => {
  var _state$Coupons$coupon;
  return (_state$Coupons$coupon = state.Coupons[couponId]) === null || _state$Coupons$coupon === void 0 ? void 0 : _state$Coupons$coupon.boards;
}, boards => {
  const allSigns = [];
  boards.forEach(board => {
    allSigns.push(board.signs);
  });
  return allSigns;
});
const selectSystemSize = createSelector((state, couponId, boardIndex) => selectSigns(state, couponId, boardIndex), signs => _selectSystemSize(signs));
const selectMSign = (state, couponId, board, event) => ({
  disabled: (selectEventSelections(state, couponId, board, event) || []).filter(sign => sign).length < 2,
  value: selectEventMSign(state, couponId, board, event)
});
const selectSignDistribution = (state, couponId, board, event) => {
  var _selectCouponBoard5;
  const signDistribution = ((_selectCouponBoard5 = selectCouponBoard(state, couponId, board)) === null || _selectCouponBoard5 === void 0 ? void 0 : _selectCouponBoard5.signDistribution) || [];
  if (typeof event !== 'undefined') {
    return signDistribution[event];
  }
  return signDistribution;
};
const selectReduceCount = (state, couponId) => {
  var _selectCoupon5;
  return ((_selectCoupon5 = selectCoupon(state, couponId)) === null || _selectCoupon5 === void 0 ? void 0 : _selectCoupon5.reduceModeCount) || 0;
};
const selectRequiredHedges = (state, couponId) => {
  const selectedSystemType = selectSystemType(state, couponId);
  let requiredHalfHedges = null;
  let requiredFullHedges = null;
  if (selectedSystemType === SYSTEM_RSYS || selectedSystemType === SYSTEM_USYS) {
    const system = {
      [SYSTEM_RSYS]: selectRSystem,
      [SYSTEM_USYS]: selectUSystem
    }[selectedSystemType](state, couponId);
    ({
      numHalfHedges: requiredHalfHedges,
      numFullHedges: requiredFullHedges
    } = state.Systems[system]);
  }
  return {
    requiredHalfHedges,
    requiredFullHedges
  };
};
const selectRequiredUSigns = (state, couponId) => {
  const {
    requiredHalfHedges,
    requiredFullHedges
  } = selectRequiredHedges(state, couponId);
  return !requiredHalfHedges && !requiredFullHedges ? undefined : requiredFullHedges + requiredHalfHedges;
};
const selectCurrentWeek = (state, couponId) => {
  var _selectCoupon6;
  const activeCompetitionId = selectActiveCompetitionId(state);
  const wallet = selectActiveWallet(state);
  const isActiveMarketplace = isMarketplaceWallet(wallet);
  if (activeCompetitionId || isActiveMarketplace) {
    return 1;
  }
  return selectEngineDefinition(state).weeks[((_selectCoupon6 = selectCoupon(state, couponId)) === null || _selectCoupon6 === void 0 ? void 0 : _selectCoupon6.week) || 0];
};
const selectCurrentAddonPixSizeIndex = (state, couponId) => {
  var _selectCoupon7;
  const pixSizes = selectEngineDefinition(state).addonPixSize;
  const pixSizeIndex = pixSizes.indexOf(selectEngineDefinition(state).addonPixSize[((_selectCoupon7 = selectCoupon(state, couponId)) === null || _selectCoupon7 === void 0 ? void 0 : _selectCoupon7.selectedAddonPixIndex) || 0]);
  return pixSizeIndex;
};
const selectRelatedDrawCoupon = (state, couponId) => {
  const coupon = selectCoupon(state, couponId);
  let relatedCoupon;
  if (coupon) {
    const {
      productId,
      drawNumber
    } = coupon;
    const relatedDraw = makeSelectRelatedDraw(productId, drawNumber, constants.RelatedProductType.PIX.toUpperCase())(state) || {};
    const {
      productId: relatedProductId,
      drawNumber: relatedDrawNumber
    } = relatedDraw;
    const relatedCouponId = "".concat(relatedProductId, "_").concat(relatedDrawNumber, "_pix");
    relatedCoupon = selectCoupon(state, relatedCouponId);
  }
  return relatedCoupon;
};
const selectIsSportkryssSupported = state => {
  const wallet = selectActiveWallet(state);
  const marketplaceWallet = isMarketplaceWallet(wallet);
  const isSportkryssSupported = !marketplaceWallet || marketplaceWallet && svs.core.detect.feature('ft-mkp-sportkryss');
  return isSportkryssSupported;
};
const selectCurrentSportkryssFactor = (state, couponId) => {
  if (selectIsSportkryssSupported(state)) {
    var _selectCoupon8;
    return selectEngineDefinition(state).sportkryssFactors[((_selectCoupon8 = selectCoupon(state, couponId)) === null || _selectCoupon8 === void 0 ? void 0 : _selectCoupon8.sportkryss) || 0];
  }
  return 0;
};
const selectCurrentSportkryssAmount = (state, couponId) => selectCurrentSportkryssFactor(state, couponId) * selectEngineDefinition(state).sportkryssBase;
const getBoardPrice = (state, couponId, boardIndex, preCalculatedSystemSize) => {
  const betAmount = selectCurrentBetAmount(state, couponId);
  const systemSize = preCalculatedSystemSize !== null && preCalculatedSystemSize !== void 0 ? preCalculatedSystemSize : selectSystemSize(state, couponId, boardIndex);
  const reduceCount = selectReduceCount(state, couponId);
  const selectedSystemType = selectSystemType(state, couponId);
  const rSystem = selectRSystem(state, couponId);
  const uSystem = selectUSystem(state, couponId);
  const week = selectCurrentWeek(state, couponId);
  let basePrice;
  if (selectedSystemType === SYSTEM_REDUCERA_FRITT) {
    basePrice = reduceCount !== null && reduceCount !== void 0 ? reduceCount : 0;
  } else {
    const selectedSystem = {
      [SYSTEM_RSYS]: state.Systems[rSystem],
      [SYSTEM_USYS]: state.Systems[uSystem]
    }[selectedSystemType];
    if (selectedSystem) {
      const {
        signs,
        mSigns
      } = selectCouponBoard(state, couponId, boardIndex) || {
        signs: [],
        mSigns: []
      };
      const couponMSigns = signs.map(signs => signs.filter(Boolean).length).filter((dummy, i) => mSigns[i]);
      basePrice = couponMSigns.reduce((amount, sum) => amount * sum, selectedSystem.rows.length);
    } else {
      basePrice = betAmount * systemSize;
    }
  }
  return basePrice * week;
};
const isEveryMatchSelected = (state, couponId, boardIndex) => {
  const signs = selectSigns(state, couponId, boardIndex) || [];
  const isEveryMatchSelected = signs.filter(selections => selections.filter(Boolean).length > 0).length === signs.length;
  return isEveryMatchSelected;
};
const getPriceOfBoards = (state, couponId, couponBoards) => {
  let price = 0;
  const hasMultipleBoards = couponBoards.length > 1;
  for (let boardIndex = 0; boardIndex < couponBoards.length; ++boardIndex) {
    var _selectCoupon9;
    if (!((_selectCoupon9 = selectCoupon(state, couponId)) !== null && _selectCoupon9 !== void 0 && _selectCoupon9.isExternal)) {
      const includeBoard = !hasMultipleBoards || isEveryMatchSelected(state, couponId, boardIndex);
      if (includeBoard) {
        price += getBoardPrice(state, couponId, boardIndex);
      }
    } else {
      price += getBoardPrice(state, couponId, boardIndex, couponBoards[boardIndex].systemSize);
    }
  }
  return price;
};
const getPriceOfAllBoards = (state, couponId) => {
  var _selectCoupon10;
  const couponBoards = ((_selectCoupon10 = selectCoupon(state, couponId)) === null || _selectCoupon10 === void 0 ? void 0 : _selectCoupon10.boards) || [];
  const price = getPriceOfBoards(state, couponId, couponBoards);
  return price;
};
const selectSportkryssPrice = (state, couponId) => {
  const week = selectCurrentWeek(state, couponId);
  const sportkryssFactor = selectCurrentSportkryssFactor(state, couponId);
  const sportkryssBase = selectEngineDefinition(state).sportkryssBase;
  const sportkryssPrice = sportkryssFactor * sportkryssBase * week;
  return sportkryssPrice;
};
const selectSportkryssNumber = (state, couponId) => {
  var _selectCoupon11;
  return ((_selectCoupon11 = selectCoupon(state, couponId)) === null || _selectCoupon11 === void 0 ? void 0 : _selectCoupon11.sportkryssNumber) || '';
};
const selectIsRelatedCouponValid = (state, couponId) => {
  const couponStatus = selectCouponStatus(state, couponId);
  const pixSize = selectCurrentAddonPixSizeIndex(state, couponId);
  return Boolean(pixSize && couponStatus === COUPON_VALID);
};
const selectRelatedCouponPrice = (state, couponId) => {
  const relatedCoupon = selectRelatedDrawCoupon(state, couponId);
  if (!relatedCoupon) {
    return 0;
  }
  const {
    productId: relatedProductId,
    drawNumber: relatedDrawNumber
  } = relatedCoupon;
  const relatedCouponId = "".concat(relatedProductId, "_").concat(relatedDrawNumber, "_pix");
  const pixSizes = selectAddonPixSizes(state);
  const selectedPixIndex = selectCurrentAddonPixSizeIndex(state, relatedCouponId);
  return selectedPixIndex ? pixSizes[selectedPixIndex] : 0;
};
const selectPrice = function (state, couponId) {
  let shouldSelectRelated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let relatedPrice = 0;
  const wallet = selectActiveWallet(state);
  const hasRelatedDrawPix = detect.feature('ft-tipsen-addon-pix');
  if (shouldSelectRelated && !isMarketplaceWallet(wallet) && hasRelatedDrawPix) {
    relatedPrice = selectRelatedCouponPrice(state, couponId);
  }
  return getPriceOfAllBoards(state, couponId) + selectSportkryssPrice(state, couponId) + relatedPrice;
};
const getReduceModeStatus = (state, couponId, boardIndex) => {
  const reduceModeCount = selectReduceCount(state, couponId);
  const isReduceModeCountWithinRange = reduceModeCount >= constants.reduceModeRange.MIN && reduceModeCount <= constants.reduceModeRange.MAX;
  if (!isReduceModeCountWithinRange) {
    return COUPON_INVALID_REDUCE_COUNT_NOT_IN_RANGE;
  }
  const possibleRows = selectSystemSize(state, couponId, boardIndex);
  const isReduceModeCountValid = reduceModeCount < possibleRows;
  if (!isReduceModeCountValid) {
    return COUPON_INVALID_REDUCE_COUNT_TOO_GREAT;
  }
};
const getSystemStatus = (state, couponId, boardIndex) => {
  const {
    requiredHalfHedges,
    requiredFullHedges
  } = selectRequiredHedges(state, couponId);
  const selectedFullHedges = selectFullHedges(state, couponId, boardIndex);
  const selectedHalfHedges = selectHalfHedges(state, couponId, boardIndex);
  if (selectedFullHedges !== requiredFullHedges || selectedHalfHedges !== requiredHalfHedges) {
    return COUPON_INVALID_WRONG_HEDGES;
  }
  const selectedSystemType = selectSystemType(state, couponId);
  if (selectedSystemType === SYSTEM_USYS) {
    const numHedges = selectedFullHedges + selectedHalfHedges;
    const selectedUSigns = (selectUSigns(state, couponId, boardIndex) || []).filter(uSign => uSign !== null);
    const isUSignsOK = numHedges === selectedUSigns.length;
    if (!isUSignsOK) {
      return COUPON_INVALID_WRONG_USIGNS;
    }
  }
};
const selectCouponStatus = (state, couponId) => {
  var _selectCoupon12;
  const coupon = selectCoupon(state, couponId);
  if (coupon !== null && coupon !== void 0 && coupon.isExternal) {
    return COUPON_VALID;
  }
  let numCompleteRows = 0;
  let hasIncompleteRow = false;
  const productId = coupon === null || coupon === void 0 ? void 0 : coupon.productId;
  const drawNumber = coupon === null || coupon === void 0 ? void 0 : coupon.drawNumber;
  const draw = selectDraw(state, productId, drawNumber);
  const price = selectPrice(state, couponId);
  const minStake = selectEngineDefinition(state).minStake;
  const couponBoards = ((_selectCoupon12 = selectCoupon(state, couponId)) === null || _selectCoupon12 === void 0 ? void 0 : _selectCoupon12.boards) || [];
  const hasMultipleBoards = couponBoards.length > 1;
  for (let boardIndex = 0; boardIndex < couponBoards.length; ++boardIndex) {
    const systemSize = selectSystemSize(state, couponId, boardIndex);
    const maxSystemSize = selectEngineDefinition(state).maxSystemSize;
    const selectedSystemType = selectSystemType(state, couponId);
    if (selectedSystemType === SYSTEM_MSYS && systemSize > maxSystemSize) {
      return COUPON_INVALID_MAX_SIZE_EXCEEDED;
    }
    const isBoardComplete = isEveryMatchSelected(state, couponId, boardIndex);
    if (hasMultipleBoards) {
      if (isBoardComplete) {
        numCompleteRows += 1;
        continue;
      } else {
        hasIncompleteRow = true;
      }
    } else if (!isBoardComplete) {
      return COUPON_INVALID_NO_COMPLETE_BOARD;
    }
    let systemStatus;
    if (selectedSystemType === SYSTEM_REDUCERA_FRITT) {
      systemStatus = getReduceModeStatus(state, couponId, boardIndex);
    } else if (selectedSystemType === SYSTEM_RSYS || selectedSystemType === SYSTEM_USYS) {
      systemStatus = getSystemStatus(state, couponId, boardIndex);
    }
    if (systemStatus) {
      return systemStatus;
    }
  }

  if (hasIncompleteRow && numCompleteRows === 0) {
    return COUPON_INVALID_NO_COMPLETE_BOARD;
  }
  const wallet = selectActiveWallet(state);
  const {
    minGroupAmount
  } = selectEngineDefinition(state);
  if ((wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_MARKETPLACE_RETAILER && selectPrice(state, couponId) < minGroupAmount) {
    return COUPON_INVALID_BELOW_GROUP_AMOUNT;
  }
  if (price < minStake) {
    return COUPON_PRICE_IS_LOWER_THAN_MINSTAKE;
  }
  const shouldIgnoreCompetition = draw && draw.isLite;
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails && !shouldIgnoreCompetition) {
    const sysType = competitionDetails.systemType;
    if (sysType === SYSTEM_MSYS) {
      const systemSize = selectSystemSize(state, couponId, 0);
      if (systemSize !== competitionDetails.systemNumber) {
        return COUPON_DONT_MATCH_COMPETITION_SYSTEMSIZE;
      }
    } else if (sysType === SYSTEM_RSYS) {
      return COUPON_DONT_MATCH_COMPETITION_SYSTEMSIZE;
    } else if (sysType === SYSTEM_USYS) {
      return COUPON_DONT_MATCH_COMPETITION_SYSTEMSIZE;
    }
  }
  return COUPON_VALID;
};
const getGameBoardSystemType = (state, couponId, boardIndex) => {
  const system = selectSystemType(state, couponId);
  if (system === SYSTEM_MSYS) {
    const numHalfHedges = selectHalfHedges(state, couponId, boardIndex);
    const numFullHedges = selectFullHedges(state, couponId, boardIndex);
    if (numHalfHedges > 0 || numFullHedges > 0) {
      return MSYS;
    }
    return SROW;
  } else if (system === SYSTEM_RSYS) {
    return RSYS;
  } else if (system === SYSTEM_USYS) {
    return USYS;
  }
};
const selectHasBoardUserSigns = (state, couponId, boardIndex) => {
  const userSigns = selectBoardUserSigns(state, couponId, boardIndex);
  for (const row of userSigns) {
    if (row.includes(true)) {
      return true;
    }
  }
  return false;
};
const selectHasBoardSignsNotByUser = (state, couponId, boardIndex) => {
  const {
    signs,
    userSigns
  } = selectCouponBoard(state, couponId, boardIndex) || {
    signs: [],
    userSigns: []
  };
  for (const [rowIndex, rowValues] of Object.entries(signs)) {
    if (rowValues.includes(true) && rowValues.toString() !== userSigns[rowIndex].toString()) {
      return true;
    }
  }
  return false;
};
const selectBoardQuickpickVariant = (state, couponId, boardIndex) => {
  var _board$pixVariant;
  const board = selectCouponBoard(state, couponId, boardIndex);
  return (_board$pixVariant = board === null || board === void 0 ? void 0 : board.pixVariant) !== null && _board$pixVariant !== void 0 ? _board$pixVariant : null;
};
const selectCouponQuickpickVariant = (state, couponId) => {
  var _selectCoupon13;
  const couponBoards = ((_selectCoupon13 = selectCoupon(state, couponId)) === null || _selectCoupon13 === void 0 ? void 0 : _selectCoupon13.boards) || [];
  const foundPixVariants = {};
  for (const board of couponBoards) {
    if (board.pixVariant && !foundPixVariants[board.pixVariant]) {
      foundPixVariants[board.pixVariant] = board.pixVariant;
    }
  }
  return foundPixVariants[QUICKPICK_MODIFIED] || foundPixVariants[QUICKPICK_PARTIAL] || foundPixVariants[QUICKPICK_WEIGHTED] || null;
};
const selectHasUserSigns = (state, couponId) => {
  var _selectCoupon14;
  const couponBoards = ((_selectCoupon14 = selectCoupon(state, couponId)) === null || _selectCoupon14 === void 0 ? void 0 : _selectCoupon14.boards) || [];
  for (const board of couponBoards) {
    const hasUserSigns = Array.isArray(board.userSigns) && board.userSigns.some(userSignRow => Array.isArray ? userSignRow.includes(true) : userSignRow);
    if (hasUserSigns) {
      return true;
    }
  }
  return false;
};
const uSignToURow = {
  null: '0',
  0: '1',
  1: 'X',
  2: '2'
};
const uSignToUSys = {
  null: 0,
  0: 1,
  1: 2,
  2: 4
};
const createGame1X2BoardData = (state, couponId, boardIndex) => {
  const board = selectCouponBoard(state, couponId, boardIndex) || {
    signs: []
  };
  const boardData = [];
  const systemType = selectSystemType(state, couponId);
  const validMSignSystems = [SYSTEM_RSYS, SYSTEM_USYS].includes(systemType);
  for (let i = 0; i < board.signs.length; ++i) {
    let str = '';
    str += board.signs[i][0] ? '1' : '';
    str += board.signs[i][1] ? 'X' : '';
    str += board.signs[i][2] ? '2' : '';
    if (validMSignSystems) {
      str += board.mSigns[i] ? 'M' : '';
    }
    boardData.push(str);
  }
  return boardData;
};
const createGameGoalCountBoardData = (state, couponId, boardIndex) => {
  const board = selectCouponBoard(state, couponId, boardIndex) || {
    signs: []
  };
  const boardData = [];
  for (let i = 0; i < board.signs.length; ++i) {
    const currentRow = board.signs[i];
    const signs = [];
    for (let index = 0; index < currentRow.length; ++index) {
      if (currentRow[index]) {
        signs.push(index.toString());
      }
    }
    boardData.push(signs);
  }
  return boardData;
};
const createGameGoalCountBoards = (state, couponId, boardIndex) => {
  const systemType = selectSystemType(state, couponId);
  const gameBoardsArr = [];
  const gameBoardObject = {
    boardData: createGameGoalCountBoardData(state, couponId, boardIndex),
    systemType: getGameBoardSystemType(state, couponId, boardIndex)
  };
  const quickpickVariant = selectBoardQuickpickVariant(state, couponId, boardIndex);
  if (quickpickVariant) {
    gameBoardObject.boardProps = [quickpickVariant];
  }
  gameBoardObject.rowPriceMulti = selectCurrentBetAmount(state, couponId);
  if (systemType === SYSTEM_USYS) {
    gameBoardObject.uRowData = (selectUSigns(state, couponId, boardIndex) || []).map(uSign => uSignToUSys[uSign]);
  }
  gameBoardsArr.push(gameBoardObject);
  return gameBoardsArr;
};
const createGame1X2Boards = (state, couponId, boardIndex) => {
  const systemType = selectSystemType(state, couponId);
  const gameBoardsArr = [];
  const gameBoardObject = {
    boardData: createGame1X2BoardData(state, couponId, boardIndex),
    systemType: getGameBoardSystemType(state, couponId, boardIndex)
  };
  const quickpickVariant = selectBoardQuickpickVariant(state, couponId, boardIndex);
  if (quickpickVariant) {
    gameBoardObject.boardProps = [quickpickVariant];
  }
  const selectSystem = {
    [SYSTEM_MSYS]: () => SYSTEM_MSYS,
    [SYSTEM_RSYS]: selectRSystem,
    [SYSTEM_USYS]: selectUSystem
  };
  gameBoardObject.systemNum = state.Systems[selectSystem[systemType](state, couponId)].systemNum;
  if (systemType === SYSTEM_USYS) {
    gameBoardObject.uRowData = (selectUSigns(state, couponId, boardIndex) || []).map(uSign => uSignToUSys[uSign]);
  }
  gameBoardsArr.push(gameBoardObject);
  if (systemType === SYSTEM_USYS) {
    const uSystemBoardObject = {
      boardData: (selectUSigns(state, couponId, boardIndex) || []).map(uSign => uSignToURow[uSign]),
      systemType: UROW
    };
    gameBoardsArr.push(uSystemBoardObject);
  }
  return gameBoardsArr;
};
const selectSportkryssBetProperties = state => {
  const betProperties = [];
  const wallet = selectActiveWallet(state);
  if ((wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_MARKETPLACE_RETAILER) {
    betProperties.push(BET_PROP_MARKETPLACE, BET_PROP_MARKETPLACE_RETAILER);
  } else if ((wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_MARKETPLACE_PLAYER) {
    betProperties.push(BET_PROP_MARKETPLACE);
  }
  return betProperties;
};
const getBetProperties = (state, couponId, isPlayingCompetition) => {
  const betProperties = [];
  const wallet = selectActiveWallet(state);
  if ((wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_MARKETPLACE_RETAILER) {
    betProperties.push(BET_PROP_MARKETPLACE, BET_PROP_MARKETPLACE_RETAILER);
  } else if ((wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_MARKETPLACE_PLAYER) {
    betProperties.push(BET_PROP_MARKETPLACE);
  }
  const systemType = selectSystemType(state, couponId);
  if (systemType === SYSTEM_REDUCERA_FRITT) {
    betProperties.push(BET_PROP_REDUCERA_FRITT);
  } else if (isPlayingCompetition) {
    return new Array('COMPETITION');
  }
  return betProperties;
};
const createBet = function (state, draw, couponId, isPlayingCompetition) {
  let couponBoards = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  const bet = {
    productId: resolveITSProductId(draw.productId),
    betAmountSalesGroup1: CurrencyAsJupiterString(getPriceOfBoards(state, couponId, couponBoards)),
    betAmountSalesGroup2: '0,00',
    drawNum: draw.drawNumber,
    numDraws: selectCurrentWeek(state, couponId),
    rowPriceMulti: selectCurrentBetAmount(state, couponId)
  };
  const coupon = selectCoupon(state, couponId);
  const productId = coupon.productId;
  const engineConfig = selectEngineDefinitionByProductId(productId);
  const isGoalCount = engineConfig.outcomes.eventTypeId === EventTypeId.GOAL_COUNT;
  const betProperties = getBetProperties(state, couponId, isPlayingCompetition);
  if (betProperties.length) {
    bet.betProperties = betProperties;
  }
  const systemType = selectSystemType(state, couponId);
  const isExternal = selectIsCouponExternal(state, couponId);
  if (systemType === SYSTEM_REDUCERA_FRITT) {
    var _selectCouponBoard6;
    const percentageReducer = new Reducer(signDistributionConversion(((_selectCouponBoard6 = selectCouponBoard(state, couponId, 0)) === null || _selectCouponBoard6 === void 0 ? void 0 : _selectCouponBoard6.signDistribution) || []), selectReduceCount(state, couponId));
    bet.er1X2BoardData = {
      simpleRowsOnly: true,
      boards: convert1X2ToBitmapRows(percentageReducer.reduce())
    };
  } else if (isGoalCount && !isExternal) {
    bet.scoreBoards = [];
    for (let boardIndex = 0; boardIndex < couponBoards.length; ++boardIndex) {
      if (isEveryMatchSelected(state, couponId, boardIndex)) {
        const scoreBoardsFromBoard = createGameGoalCountBoards(state, couponId, boardIndex);
        bet.scoreBoards.push(...scoreBoardsFromBoard);
      }
    }
  } else if (isExternal) {
    var _bet$betProperties;
    const hexBoards = couponBoards.reduce((hexArray, board) => {
      const hexString = board.signs.map(signArray => signArray.reduce((acc, sign, index) => {
        if (sign) {
          acc |= 1 << index;
        }
        return acc;
      }, 0)
      .toString(16)
      .padStart(isGoalCount ? 2 : 0, '0')).join('').toUpperCase();
      hexArray.push(hexString);
      return hexArray;
    }, []);
    if (isGoalCount) {
      var _couponBoards$;
      bet.erScoreBoardData = {
        simpleRowsOnly: ((_couponBoards$ = couponBoards[0]) === null || _couponBoards$ === void 0 ? void 0 : _couponBoards$.type) === constants.boardType.BOARD_SINGLE,
        boards: hexBoards
      };
    } else {
      var _couponBoards$2;
      bet.er1X2BoardData = {
        simpleRowsOnly: ((_couponBoards$2 = couponBoards[0]) === null || _couponBoards$2 === void 0 ? void 0 : _couponBoards$2.type) === constants.boardType.BOARD_SINGLE,
        boards: hexBoards
      };
    }
    if ((_bet$betProperties = bet.betProperties) !== null && _bet$betProperties !== void 0 && _bet$betProperties.length) {
      bet.betProperties.push('EGNARADER');
    } else {
      bet.betProperties = ['EGNARADER'];
    }
  } else {
    bet.game1X2Boards = [];
    for (let boardIndex = 0; boardIndex < couponBoards.length; ++boardIndex) {
      if (isEveryMatchSelected(state, couponId, boardIndex)) {
        const game1X2BoardsFromBoard = createGame1X2Boards(state, couponId, boardIndex);
        bet.game1X2Boards.push(...game1X2BoardsFromBoard);
      }
    }
  }
  return bet;
};
const createSportkryssBet = (state, couponId) => {
  const coupon = selectCoupon(state, couponId);
  const sportkryssFactor = (coupon === null || coupon === void 0 ? void 0 : coupon.sportkryss) || 0;
  const weeks = selectCurrentWeek(state, couponId);
  const numbers = String((coupon === null || coupon === void 0 ? void 0 : coupon.sportkryssNumber) || '').split('');
  const betProperties = selectSportkryssBetProperties(state);
  const bet = {
    productId: 'SPORTJOKER',
    drawNum: 0,
    numDraws: weeks,
    betAmountSalesGroup1: CurrencyAsJupiterString(selectSportkryssPrice(state, couponId)),
    betAmountSalesGroup2: '0,00',
    rowPriceMulti: sportkryssFactor,
    jokerBoards: [{
      systemType: ['SROW'],
      numSelections: numbers.length,
      participation: 0,
      rowPriceMulti: 1,
      boardData: numbers
    }]
  };
  if (betProperties.length) {
    bet.betProperties = betProperties;
  }
  return bet;
};
const createBets = function (state, draw, couponId, isPlayingCompetition) {
  let couponBoards = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  const bets = [];
  if (selectIsSportkryssSupported(state) && selectCurrentSportkryssFactor(state, couponId) > 0) {
    bets.push(createSportkryssBet(state, couponId));
  }
  bets.push(createBet(state, draw, couponId, isPlayingCompetition, couponBoards));
  return bets;
};
const selectWager = (state, draw, couponId, isPlayingCompetition, competition, boards) => {
  var _selectCoupon15;
  const couponBoards = boards !== null && boards !== void 0 ? boards : (_selectCoupon15 = selectCoupon(state, couponId)) === null || _selectCoupon15 === void 0 ? void 0 : _selectCoupon15.boards;
  const wager = {
    crc: 0,
    marketInfo: 0,
    bagType: 0,
    bets: createBets(state, draw, couponId, isPlayingCompetition, couponBoards),
    drawNum: draw.drawNumber
  };
  if (isPlayingCompetition) {
    wager.competitionId = [competition.id];
  }
  const wallet = selectActiveWallet(state);
  if ((wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_MARKETPLACE_RETAILER) {
    wager.commissionPercent = wallet.meta.commissionPercent;
  }
  return wager;
};
const selectWagers = (state, draw, couponId, isPlayingCompetition, competition) => {
  var _selectCoupon16;
  const couponBoards = (_selectCoupon16 = selectCoupon(state, couponId)) === null || _selectCoupon16 === void 0 ? void 0 : _selectCoupon16.boards;
  const wagers = [];
  if (couponBoards) {
    const boardsChunks = [];
    const boardType = selectCoupon(state, couponId).boards[0].type;
    const wallet = selectActiveWallet(state);
    const isMarketplace = isMarketplaceWallet(wallet) ? wallet.label : null;
    const chunkMaxSize = selectExternalSystemChunkSize(state, boardType, isMarketplace);
    for (let i = 0; i < couponBoards.length; i += chunkMaxSize) {
      boardsChunks.push(couponBoards.slice(i, i + chunkMaxSize));
    }
    boardsChunks.forEach(boards => {
      const wager = selectWager(state, draw, couponId, isPlayingCompetition, competition, boards);
      wagers.push(wager);
    });
  }
  if (wagers.length > 1) {
    for (let i = 0; i < wagers.length; i++) {
      wagers[i].sequenceNum = i;
    }
  }
  return wagers;
};
const selectWagerProps = (state, draw, couponId, isPlayingCompetition, isCompetitionSignUp, competition, chunkData) => {
  var _selectCoupon17, _draw$jackpot, _draw$fund, _draw$fund2, _selectCoupon21;
  const extradata = {
    rounds: 1
  };
  const quickpickVariant = selectCouponQuickpickVariant(state, couponId);
  if (quickpickVariant) {
    extradata.quickpick = quickpickVariant;
  }
  const wallet = selectActiveWallet(state);
  const currentBalance = selectWalletBalance(state);
  const systemType = selectSystemType(state, couponId);
  const isExternal = (_selectCoupon17 = selectCoupon(state, couponId)) === null || _selectCoupon17 === void 0 ? void 0 : _selectCoupon17.isExternal;
  if (systemType === SYSTEM_REDUCERA_FRITT) {
    var _selectCoupon18;
    extradata.system = "reducera fritt ".concat(((_selectCoupon18 = selectCoupon(state, couponId)) === null || _selectCoupon18 === void 0 ? void 0 : _selectCoupon18.reduceModeCount) || 0);
  } else if (systemType === SYSTEM_RSYS) {
    var _selectCoupon19;
    extradata.system = selectEngineDefinition(state).rSystems[(_selectCoupon19 = selectCoupon(state, couponId)) === null || _selectCoupon19 === void 0 ? void 0 : _selectCoupon19.rSystem];
  } else if (systemType === SYSTEM_USYS) {
    var _selectCoupon20;
    extradata.system = selectEngineDefinition(state).uSystems[(_selectCoupon20 = selectCoupon(state, couponId)) === null || _selectCoupon20 === void 0 ? void 0 : _selectCoupon20.uSystem];
  } else {
    extradata.system = "M ".concat(selectSystemSize(state, couponId, 0));
  }
  extradata.competition = 'None';
  if (isPlayingCompetition && competition) {
    extradata.competition = competition.compType;
  }
  const regOpenTimeDate = new Date(draw.regOpenTime);
  extradata.draw = "".concat(dateFns.getISOWeek(regOpenTimeDate), "-").concat(draw.drawNumber);
  const jackpot = ((_draw$jackpot = draw.jackpot) === null || _draw$jackpot === void 0 ? void 0 : _draw$jackpot.jackpotAmount) || 0;
  const extraPengar = ((_draw$fund = draw.fund) === null || _draw$fund === void 0 ? void 0 : _draw$fund.extraMoney) || 0;
  const rullPott = ((_draw$fund2 = draw.fund) === null || _draw$fund2 === void 0 ? void 0 : _draw$fund2.rolloverIn) || 0;
  extradata.fund = "Jackpot:".concat(jackpot, ",ExtraPengar:").concat(extraPengar, ",Rullpott:").concat(rullPott);
  const getDisplayNameByDraw = selectEngineDefinition(state).getDisplayNameByDraw;
  const wagerprops = {
    productId: resolveITSProductId(draw.productId),
    betAmount: isExternal ? (_selectCoupon21 = selectCoupon(state, couponId)) === null || _selectCoupon21 === void 0 ? void 0 : _selectCoupon21.totalPrice : selectPrice(state, couponId),
    extradata
  };
  if (chunkData) {
    wagerprops.chunkData = chunkData;
    wagerprops.noAccountbalanceUpdate = true;
  }

  const appendMessage = !chunkData || chunkData.index === 0;
  if (appendMessage) {
    var _selectCoupon22;
    wagerprops.message = getPaymentConfirmMessage({
      productName: getDisplayNameByDraw(draw),
      amount: isExternal ? (_selectCoupon22 = selectCoupon(state, couponId)) === null || _selectCoupon22 === void 0 ? void 0 : _selectCoupon22.totalPrice : selectPrice(state, couponId),
      compDesc: isPlayingCompetition ? competition.compDesc : '',
      marketplaceGroup: isMarketplaceWallet(wallet) ? wallet.label : null,
      isRetailer: (wallet === null || wallet === void 0 ? void 0 : wallet.type) === WALLET_MARKETPLACE_RETAILER,
      isMultipleWagers: Boolean(chunkData && chunkData.total > 1)
    });
  }
  if (isMarketplaceWallet(wallet)) {
    wagerprops.marketplaceAccount = {};
    if (wallet.type === WALLET_MARKETPLACE_RETAILER) {
      wagerprops.marketplaceAccount.activatedDrawId = wallet.meta.activatedDrawId;
      wagerprops.marketplaceAccount.balance = currentBalance;
    } else {
      wagerprops.marketplaceAccount.activatedDrawId = wallet.meta.ActivatedDrawId;
      wagerprops.marketplaceAccount.balance = wallet.meta.Balance;
    }
  } else {
    const nrOfSelectedWeeks = selectCurrentWeek(state, couponId);
    wagerprops.rounds = nrOfSelectedWeeks;
    wagerprops.extradata.rounds = nrOfSelectedWeeks;
  }
  if (isPlayingCompetition && isCompetitionSignUp) {
    wagerprops.competitionSignUp = competition;
  }
  return wagerprops;
};
const selectCouponSignCount = RTK.createSelector(selectCoupon, coupon => {
  var _coupon$boards;
  const boards = (_coupon$boards = coupon === null || coupon === void 0 ? void 0 : coupon.boards) !== null && _coupon$boards !== void 0 ? _coupon$boards : [];
  const init = 0;
  const signsCount = flatArray(boards.map(b => b.signs.map(r => r.filter(s => s).length))).reduce((acc, curr) => acc + curr, init);
  return signsCount;
});
const selectMSignsCount = (state, couponId) => {
  var _coupon$boards2;
  const coupon = selectCoupon(state, couponId);
  const boards = (_coupon$boards2 = coupon === null || coupon === void 0 ? void 0 : coupon.boards) !== null && _coupon$boards2 !== void 0 ? _coupon$boards2 : [{
    mSigns: []
  }];
  const init = 0;
  const signsCount = boards.map(b => b.mSigns.filter(r => r).length).reduce((acc, curr) => acc + curr, init);
  return signsCount;
};
const selectCouponEmpty = (state, couponId) => {
  var _selectCoupon23;
  const couponBoards = ((_selectCoupon23 = selectCoupon(state, couponId)) === null || _selectCoupon23 === void 0 ? void 0 : _selectCoupon23.boards) || [];
  if (couponBoards.length < 1) {
    return true;
  }
  for (const board of couponBoards) {
    for (const row of board.signs) {
      if (row.includes(true)) {
        return false;
      }
    }
  }
  return true;
};
const selectCouponBoardEmpty = (state, couponId, boardIndex) => {
  const signs = selectSigns(state, couponId, boardIndex) || [];
  for (const row of signs) {
    if (row.includes(true)) {
      return false;
    }
  }
  return true;
};
const selectBetslipCouponType = (state, couponId) => {
  var _selectCoupon24;
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails) {
    return BetslipCouponType.Competition;
  }
  const isExternal = selectIsCouponExternal(state, couponId);
  if (isExternal) {
    return BetslipCouponType.ExternaSystemspel;
  }
  if ((((_selectCoupon24 = selectCoupon(state, couponId)) === null || _selectCoupon24 === void 0 ? void 0 : _selectCoupon24.boards) || []).length > 1) {
    return BetslipCouponType.Enkelrader;
  }
  const systemType = selectSystemType(state, couponId);
  switch (systemType) {
    case SYSTEM_MSYS:
      return BetslipCouponType.Standard;
    case SYSTEM_RSYS:
      return BetslipCouponType.RSystem;
    case SYSTEM_USYS:
      return BetslipCouponType.USystem;
    case SYSTEM_REDUCERA_FRITT:
      return BetslipCouponType.ReduceraFritt;
    default:
      throw new Error('Unknown Betslip Coupon Type');
  }
};
const selectNumberOfBoards = (state, couponId) => {
  var _selectCoupon25;
  return (((_selectCoupon25 = selectCoupon(state, couponId)) === null || _selectCoupon25 === void 0 ? void 0 : _selectCoupon25.boards) || []).length;
};
const selectNumberOfCompletedBoards = (state, couponId) => {
  var _selectCoupon26;
  let c = 0;
  const couponBoards = ((_selectCoupon26 = selectCoupon(state, couponId)) === null || _selectCoupon26 === void 0 ? void 0 : _selectCoupon26.boards) || [];
  for (const board of couponBoards) {
    let boardIsEmpty = false;
    for (const row of board.signs) {
      if (!row.includes(true)) {
        boardIsEmpty = true;
        break;
      }
    }
    if (!boardIsEmpty) {
      c++;
    }
  }
  return c;
};
const selectUSignsCount = function (state, couponId) {
  let board = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  let c = 0;
  const uSigns = selectUSigns(state, couponId, board) || [];
  for (const row of uSigns) {
    if (row !== null) {
      c++;
    }
  }
  return c;
};
const selectPixSize = function (state, couponId) {
  var _selectCouponBoard7;
  let board = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const activeCompetitionId = selectActiveCompetitionId(state);
  const competitionDetails = selectCompetitionDetails(state, activeCompetitionId);
  if (competitionDetails) {
    if (competitionDetails.systemType === SYSTEM_MSYS) {
      return competitionDetails.systemNumber;
    }
    return null; 
  }

  return (_selectCouponBoard7 = selectCouponBoard(state, couponId, board)) === null || _selectCouponBoard7 === void 0 ? void 0 : _selectCouponBoard7.pixSize;
};

const selectLastSelectedSystem = (state, couponId) => {
  var _selectCoupon27;
  return ((_selectCoupon27 = selectCoupon(state, couponId)) === null || _selectCoupon27 === void 0 ? void 0 : _selectCoupon27.lastSelectedSystemType) || 1;
};
const selectXpertAnalysisAuthorId = (state, couponId) => {
  var _selectCoupon28;
  return (_selectCoupon28 = selectCoupon(state, couponId)) === null || _selectCoupon28 === void 0 ? void 0 : _selectCoupon28.xpertAnalysisAuthorId;
};
const makeSelectIsCouponEmpty = () => RTK.createSelector(selectSigns, selectUserSigns, (signs, userSigns) => !flatArray(signs || []).some(sign => sign) && !flatArray(userSigns || []).some(sign => sign));
const isRSystemChoosen = (state, couponId) => selectSelectedSystemType(state, couponId) === SYSTEM_RSYS && selectRSystem(state, couponId) !== undefined;
const isUSystemChoosen = (state, couponId) => selectSelectedSystemType(state, couponId) === SYSTEM_USYS && selectUSystem(state, couponId) !== undefined;
const isReduceSystemChoosen = (state, couponId) => selectSelectedSystemType(state, couponId) === SYSTEM_REDUCERA_FRITT;
const selectPixSizeSingleRow = (state, couponId) => {
  var _selectCoupon29;
  return (((_selectCoupon29 = selectCoupon(state, couponId)) === null || _selectCoupon29 === void 0 ? void 0 : _selectCoupon29.boards) || []).filter(board => board.pixSize).length;
};
setGlobal('svs.components.tipsen.engine.selectors.couponSelectors', {
  isReduceSystemChoosen,
  isRSystemChoosen,
  selectIsSportkryssSupported,
  isUSystemChoosen,
  makeSelectIsCouponEmpty,
  selectAllSigns,
  selectBetslipCouponType,
  selectBoardQuickpickVariant,
  selectBoardUserSigns,
  selectCoupon,
  selectCouponEventCount,
  selectCouponEventStarted,
  selectCouponBoardEmpty,
  selectCouponEmpty,
  selectCouponQuickpickVariant,
  selectCouponSet,
  selectCouponSignCount,
  selectCouponStatus,
  selectCurrentAddonPixSizeIndex,
  selectCurrentBetAmount,
  selectCurrentSportkryssAmount,
  selectCurrentSportkryssFactor,
  selectCurrentWeek,
  selectEventSelections,
  selectEventUserSelections,
  selectEventUSign,
  selectFullHedges,
  selectHalfHedges,
  selectHasBoardSignsNotByUser,
  selectHasBoardUserSigns,
  selectHasUserSigns,
  selectIsCouponExternal,
  selectIsRelatedCouponValid,
  selectIsTransferrable,
  selectLastSelectedSystem,
  selectMSign,
  selectMSigns,
  selectMSignsCount,
  selectNumberOfBoards,
  selectNumberOfCompletedBoards,
  selectPixSize,
  selectPixSizeSingleRow,
  selectPrice,
  selectQuickpickValue: selectBoardQuickpickVariant,
  selectReduceCount,
  selectRelatedDrawCoupon,
  selectRequiredHedges,
  selectRequiredUSigns,
  selectRSystem,
  selectSelectedSystemType,
  selectSignDistribution,
  selectSigns,
  selectSportkryssNumber,
  selectSportkryssPrice,
  selectSystemSize,
  selectSystemType,
  selectUserSigns,
  selectUserSystemSize,
  selectUSigns,
  selectUSignsCount,
  selectUSystem,
  selectWager,
  selectWagerProps,
  selectWagers,
  selectXpertAnalysisAuthorId
});
 })(window);